import React from "react";
import { cn } from "@/lib/utils";

interface DeviceFrameProps {
  className?: string;
  children?: React.ReactNode;
}

const DeviceFrame: React.FC<DeviceFrameProps> = ({ className, children }) => {
  return (
    <div className={cn("relative", className)}>
      <div className="relative rounded-[2rem] border border-border bg-foreground/90 p-3 shadow-medium">
        {/* Notch */}
        <div className="absolute top-3 left-1/2 -translate-x-1/2 h-4 w-24 rounded-b-2xl bg-foreground" />
        {/* Screen */}
        <div className="rounded-[1.5rem] overflow-hidden bg-background aspect-[9/19]">
          {children}
        </div>
      </div>
    </div>
  );
};

export default DeviceFrame;
